import { CompanySelectorWebComponent } from './component/CompanySelectorWebComponent';
import { WEB_COMPONENT_COMPANY_SELECTOR } from '../webcomponents.constants';

export { CompanySelectorWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_SELECTOR, CompanySelectorWebComponent);
